import BaseQuery from "./BaseQuery";

export default class Translation extends BaseQuery {
    static translate(phrases, lang, successCb, errCb, eventId = 0) {

        let params = {
            p: 'api',
            op: 'translate',
            lang: !!lang ? lang : 'ru',
            phrases: phrases,
            event_id: eventId
        };

        Translation.queryGet(params, (data) => {
            if(data.hasOwnProperty('translation')) {
                successCb(data.translation);
                return;
            }
            errCb();
        }, errCb);
    }
}
